// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.stat-card[data-v-4a03d546] { text-align: center;\n}\n.stat-card .stat-num[data-v-4a03d546] { font-size: 28px; font-weight: 700; color: #303133;\n}\n.stat-card .stat-label[data-v-4a03d546] { font-size: 13px; color: #909399; margin-top: 5px;\n}\r\n", ""]);
// Exports
module.exports = exports;
